'use client'

/**
 * klaviyo 事件上报
 */
const reportKlaviyoEvent = (data: object) => {
  if (!process.env.NEXT_PUBLIC_KLAVIYO_ID) {
    return
  }

  if (typeof window.klaviyo === 'undefined') {
    window.klaviyo = []
  }

  window.klaviyo.push(data)
}

export default reportKlaviyoEvent
